import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DeployedYear, DropdownMonthList, DropdownNumberOfCustomerList, EmptyString, InsertDateFormat } from "utils/Constant";
import { ApiGetCashInList, ApiGetCustomerPaymentSummary, ApiGetCustomerRankStatistic, ApiGetDailyTransactionStatistic, ApiGetDashboardInfo, ApiGetTransactionList, ApiGetTransactionStatistic, ApiGetTransferPLList } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import Dropdown from "components/Input/Dropdown";
import { money } from "utils/helpers";
import moment from "moment";
import SalesChart from "components/Charts/SalesChart";
import ProfitChart from "components/Charts/ProfitChart";
import CustomerRankChart from "components/Charts/CustomerRankChart";
import DailyTransactionChart from "components/Charts/DailyTransactionChart";
import DatePicker from "components/Input/DatePicker";

export default function StatisticReport(){
    let navigate = useNavigate()

    const {fetch: getTransactionStatictic } = useFetch(ApiGetTransactionStatistic)
    const {fetch: getCustomerRank } = useFetch(ApiGetCustomerRankStatistic)
    const {fetch: getDailyTransactionStatistic } = useFetch(ApiGetDailyTransactionStatistic)
    const { data: transactionAnjasmoro, fetch: apiGetTransactionAnjasmoro } = useFetch(ApiGetTransactionList)
    const { data: transactionTlogosari, fetch: apiGetTransactionTlogosari } = useFetch(ApiGetTransactionList)
    const { data: dashboardData, fetch: apiGetDashboardData } = useFetch(ApiGetDashboardInfo)
    
    const { fetch: apiGetCustomerPaymentSummary } = useFetch(ApiGetCustomerPaymentSummary)
    const { fetch: apiGetCashIn } = useFetch(ApiGetCashInList)
    const { fetch: apiGetTransferPL } = useFetch(ApiGetTransferPLList)

    const [year, setYear] = useState(moment(new Date()).format("yyyy"))
    const [customerRankYear, setCustomerRankYear] = useState(moment(new Date()).format("yyyy"))
    const [customerRankMonth, setCustomerRankMonth] = useState(moment(new Date()).format("M"))
    const [yearOptions, setYearOptions] = useState([])
    const [numberOfCustomer, setNumberOfCustomer] = useState(DropdownNumberOfCustomerList[0].value)
    const [salesData, setSalesData] = useState([
        {monthCode: "1", month: "January", sales: 0, profit: 0},
        {monthCode: "2", month: "February", sales: 0, profit: 0},
        {monthCode: "3", month: "March", sales: 0, profit: 0},
        {monthCode: "4", month: "April", sales: 0, profit: 0},
        {monthCode: "5", month: "May", sales: 0, profit: 0},
        {monthCode: "6", month: "June", sales: 0, profit: 0},
        {monthCode: "7", month: "July", sales: 0, profit: 0},
        {monthCode: "8", month: "August", sales: 0, profit: 0},
        {monthCode: "9", month: "September", sales: 0, profit: 0},
        {monthCode: "10", month: "October", sales: 0, profit: 0},
        {monthCode: "11", month: "November", sales: 0, profit: 0},
        {monthCode: "12", month: "December", sales: 0, profit: 0},
    ])
    const [customerRankData, setCustomerRankData] = useState([])
    const [customerRankSortByOptions, setCustomerRankSortByOptions] = useState([
        {label: "Sales", value: "1"},
        {label: "Profit", value: "2"}
    ])
    const [customerRankSortBy, setCustomerRankSortBy] = useState(customerRankSortByOptions[0].value)
    const [dailyTransactionMonth, setDailyTransactionMonth] = useState(moment(new Date()).format("M"))
    const [dailyTransactionYear, setDailyTransactionYear] = useState(moment(new Date()).format("yyyy"))
    const [dailyTransactionData, setDailyTransactionData] = useState([])

    const [date, setDate] = useState(new Date())
    const [transactionAmountAnjasmoro, setTransactionAmountAnjasmoro] = useState(0)
    const [transactionAmountTlogosari, setTransactionAmountTlogosari] = useState(0)
    const [totalTransferAmount, setTotalTransferAmount] = useState(0)
    const [totalCashAmount, setTotalCashAmount] = useState(0)
    const [totalTransferAnjasmoro, setTotalTransferAnjasmoro] = useState(0)
    const [totalTransferTlogosari, setTotalTransferTlogosari] = useState(0)
    const [totalCashAnjasmoro, setTotalCashAnjasmoro] = useState(0)
    const [totalCashTlogosari, setTotalCashTlogosari] = useState(0)
    const [totalCashInAmount, setTotalCashInAmount] = useState("0")
    const [totalTransferPLAmount, setTotalTransferPLAmount] = useState("0")

    const [totalSales, setTotalSales] = useState(0)
    const [salesAnjasmoro, setSalesAnjasmoro] = useState(0)
    const [salesTlogosari, setSalesTlogosari] = useState(0)
    const [totalTransfer, setTotalTransfer] = useState(0)
    const [transferAnjasmoro, setTransferAnjasmoro] = useState(0)
    const [transferTlogosari, setTransferTlogosari] = useState(0)
    const [totalCash, setTotalCash] = useState(0)
    const [cashAnjasmoro, setCashAnjasmoro] = useState(0)
    const [cashTlogosari, setCashTlogosari] = useState(0)
    const [cashIn, setCashIn] = useState(0)
    const [transferPL, setTransferPL] = useState(0)
    
    const yearChange = (e) => {
        setYear(e.value)
    }
    const customerRankYearChange = (e) => {
        setCustomerRankYear(e.value)
    }
    const customerRankMonthChange = (e) => {
        setCustomerRankMonth(e.value)
    } 
    const numberOfCustomerChange = (e) => {
        setNumberOfCustomer(e.value)
    } 
    const customerRankSortByChange = (e) => {
        setCustomerRankSortBy(e.value)
    } 
    const getYearOptions = () => {
        let startYear = parseInt(DeployedYear)
        let thisYear = parseInt(moment(new Date()).format("yyyy"))

        let tempArray = []
        for (let i = startYear; i <= thisYear; i++){
            tempArray.push( {label: String(i), value: String(i)} )
        }

        setYearOptions(tempArray)
    }
    const dailyTransactionMonthChange = (e) => {
        setDailyTransactionMonth(e.value)
    }
    const dailyTransactionYearChange = (e) => {
        setDailyTransactionYear(e.value)
    }

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
    const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        // getYearOptions()
        // getTransactionListAnjasmoro().then(() => {
        //     getTransactionListTlogosari().then(() => {
        //         getCustomerPaymentSummary().then(() => {
        //             getCashIn().then(() => {
        //                 getTransferPL()
        //             })
        //         })
        //     })
        // })
        getDashboardInfo()
    },[])

    useEffect(() => {
        setLoading({isOpen: true})

        fGetTransactionStatistic().then(() => {
            setLoading({isOpen: false})
        })
    },[year])

    useEffect(() => {
        setLoading({isOpen: true})

        fGetCustomerRankStatistic().then(() => {
            setLoading({isOpen: false})
        })
    },[numberOfCustomer, customerRankYear, customerRankMonth, customerRankSortBy])

    useEffect(() => {
        setLoading({isOpen: true})

        fGetDailyTransactionStatistic().then(() => {
            setLoading({isOpen: false})
        })
    },[dailyTransactionMonth, dailyTransactionYear])

    // Function Api Call
    async function fGetTransactionStatistic(){
        await getTransactionStatictic({
            data: {
                accYear: year
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data

                for (let i = 0; i < data.length; i++){
                    for (let j = 0; j < salesData.length; j++){
                        if (salesData[j].monthCode === data[i].month){
                            salesData[j].sales = data[i].sales
                            salesData[j].profit = data[i].profit
                        }
                    }
                    
                }
                
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetCustomerRankStatistic(){
        await getCustomerRank({
            data: {
                accYear: customerRankYear,
                accMonth: customerRankMonth,
                numberOfCustomer: numberOfCustomer,
                sortBy: customerRankSortBy
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data

                setCustomerRankData(data)
                // for (let i = 0; i < data.length; i++){
                //     for (let j = 0; j < salesData.length; j++){
                //         if (salesData[j].monthCode === data[i].month){
                //             salesData[j].sales = data[i].sales
                //             salesData[j].profit = data[i].profit
                //         }
                //     }
                    
                // }
                
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetDailyTransactionStatistic(){
        await getDailyTransactionStatistic({
            data: {
                accYear: dailyTransactionYear,
                accMonth: dailyTransactionMonth
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data

                setDailyTransactionData(data)                
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    const getDashboardInfo = async () => {
        await apiGetDashboardData({
            data: {
                transactionDate: date,
                month: moment(date).format("M"),
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data

                setSalesAnjasmoro(data.salesAnjasmoro)
                setSalesTlogosari(data.salesTlogosari)
                setTotalSales(data.salesAnjasmoro + data.salesTlogosari)
                setTransferAnjasmoro(data.transferAnjasmoro)
                setTransferTlogosari(data.transferTlogosari)
                setTotalTransfer(data.totalTransfer)
                setCashAnjasmoro(data.cashAnjasmoro)
                setCashTlogosari(data.cashTlogosari)
                setTotalCash(data.totalCash)
                setCashIn(data.cashIn)
                setTransferPL(data.transferPL)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    const getTransactionListAnjasmoro = async () => {
        await apiGetTransactionAnjasmoro({
            data: {
                dateFrom: moment(new Date()).format(InsertDateFormat),
                dateTo: moment(new Date()).format(InsertDateFormat), 
                customerName: EmptyString,
                cardNumber: EmptyString,
                edcId: 0,
                status: EmptyString,
                pageSize: 100000,
                pageIndex: 0,
                updateBy: EmptyString,
                showCustomerExeption: false,
                locationId: 1
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                // let data = response.data
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    const getTransactionListTlogosari = async () => {
        await apiGetTransactionTlogosari({
            data: {
                dateFrom: moment(new Date()).format(InsertDateFormat),
                dateTo: moment(new Date()).format(InsertDateFormat), 
                customerName: EmptyString,
                cardNumber: EmptyString,
                edcId: 0,
                status: EmptyString,
                pageSize: 100000,
                pageIndex: 0,
                updateBy: EmptyString,
                showCustomerExeption: false,
                locationId: 2
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                // let data = response.data
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }    
    const getCustomerPaymentSummary = async () => {
        await apiGetCustomerPaymentSummary({
            data: {
                transactionDate: date
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data

                setTotalTransferAmount(data.totalTransfer)
                setTotalCashAmount(data.totalCash)
                setTotalTransferAnjasmoro(data.totalTransferAnjasmoro)
                setTotalTransferTlogosari(data.totalTransferTlogosari)
                setTotalCashAnjasmoro(data.totalCashAnjasmoro)
                setTotalCashTlogosari(data.totalCashTlogosari)
                // setTransferDetailList(data.transferDetail)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    const getCashIn = async () => {
        await apiGetCashIn({
            data: {
                cashInDate: moment(date).format(InsertDateFormat),

            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data

                setTotalCashInAmount(data?.length > 0 ? money(data?.reduce((sum, record) => sum + parseFloat(record.amount), 0)) : 0)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    const getTransferPL = async () => {
        await apiGetTransferPL({
            data: {
                transferPLDate: moment(date).format(InsertDateFormat),
                customerName: "",
                status: "1" // Active
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data

                setTotalTransferPLAmount(data?.length > 0 ? money(data?.reduce((sum, record) => sum + parseFloat(record.amount), 0)) : 0)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    return(
        <div className="flex flex-col gap-2">
            <div 
                className="flex justify-between"
            >
                <div 
                    className="flex items-end"
                >
                    <span className="font-semibold text-2xl">Dashboard</span>
                </div>
                
                <div>
                    <DatePicker className="bg-white h-8" value={date} onChange={(date) => setDate(date)} />
                </div>
            </div>
            <hr />

            <div 
                className="mt-4"
            >
                <span className="text-xl">
                    Sales Volume
                </span>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
                <div className="bg-white border rounded-md flex flex-col gap-1 px-6 py-4 w-full sm:w-6/12 ">
                    <span className="text-xl">Yupiter Anjasmoro</span>
                    <span className="text-3xl font-semibold mt-4">
                        Rp {money(salesAnjasmoro)}</span>
                </div>

                <div className="bg-white border rounded-md flex flex-col gap-1 px-6 py-4 w-full sm:w-6/12 ">
                    <span className="text-xl">Yupiter Tlogosari</span>
                    <span className="text-3xl font-semibold mt-4">
                        Rp {money(salesTlogosari)}</span>
                </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 mt-4">
                <div className="bg-white border rounded-md flex flex-col gap-1 px-6 py-4 w-full ">
                    <div className="flex mt-5 font-semibold">
                        <div className="w-48">
                            <span className="text-sm sm:text-base">Total Sales</span>
                        </div>
                        <div className="px-2">
                            <span className="text-sm sm:text-base">:</span>
                        </div>
                        <div>
                            <span className="text-sm sm:text-base">Rp { money(salesAnjasmoro + salesTlogosari) }</span>
                        </div>
                    </div>
                    <div className="flex font-semibold">
                        <div className="w-48">
                            <span className="text-sm sm:text-base">Total Transfer</span>
                        </div>
                        <div className="px-2">
                            <span className="text-sm sm:text-base">:</span>
                        </div>
                        <div>
                            <span className="text-sm sm:text-base">Rp { money(totalTransfer + transferPL) }</span>
                        </div>
                    </div>

                    <div className="flex mt-5">
                        <div className="w-48">
                            <span className="text-sm sm:text-base">Total Cash In</span>
                        </div>
                        <div className="px-2">
                            <span className="text-sm sm:text-base">:</span>
                        </div>
                        <div>
                            <span className="text-sm sm:text-base">Rp { money(cashIn) }</span>
                        </div>
                    </div>
                    <div className="flex ">
                        <div className="w-48">
                            <span className="text-sm sm:text-base">Total Transfer</span>
                        </div>
                        <div className="px-2">
                            <span className="text-sm sm:text-base">:</span>
                        </div>
                        <div>
                            <span className="text-sm sm:text-base">Rp { money(totalTransfer) }</span>
                        </div>
                    </div>
                    <div className="flex ">
                        <div className="w-48">
                            <span className="text-sm sm:text-base">Total Transfer PL</span>
                        </div>
                        <div className="px-2">
                            <span className="text-sm sm:text-base">:</span>
                        </div>
                        <div>
                            <span className="text-sm sm:text-base">Rp { money(transferPL) }</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-white border rounded-md flex flex-col p-4 mt-4">
                <div className="mb-5">
                    <span className="font-semibold text-2xl tracking-wide">Daily Transaction</span>
                </div>
                
                <DailyTransactionChart data={dailyTransactionData} />
            </div>

            {/* Modal */}
            {failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
            {loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}